<template>
  <div class="MarkManagement">
    <AppHeader>标记管理</AppHeader>
    <AppBox class="appBox">
      <div class="tableFilter">
        <el-form :inline="true" :model="filter" size="small" ref="form">
          <el-form-item label="系列名称">
            <el-select
              style="width: 150px"
              v-model="filter.classSubjectId"
              v-scroll="loadMore"
              placeholder="请选择"
              @change="classNameChanged"
            >
              <el-option
                v-for="item in classNameList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="课程标题">
            <el-select
              style="width: 100px"
              v-model="filter.lessonId"
              placeholder="请选择"
              @change="onSubmit"
            >
              <el-option
                v-for="item in lessonList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="标记日期">
            <el-date-picker
              style="width: 250px"
              v-model="filter.dateRange"
              value-format="timestamp"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              @change="onSubmit"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查找</el-button>
            <el-button @click="onReset">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <MarkResponseList></MarkResponseList>
    </AppBox>
  </div>
</template>

<script>
import AppBox from "@/components/ui/AppBox/index.vue";
import AppHeader from "@/components/ui/AppHeader/index.vue";
import { mapActions, mapMutations, mapState } from "vuex";
import MarkResponseList from "@/pages/MarkManagement/MarkResponseList.vue";

export default {
  name: "MarkManagement",
  components: { MarkResponseList, AppHeader, AppBox },
  data() {
    return {
      lessonList: [
        {
          id: null,
          name: "全部",
        }
      ],
      classNameList: [
        {
          id: null,
          name: "全部",
        },
      ],
    };
  },
  watch: {
    // "$route.params.lessonName": async function (newVal, oldVal) {
    //   if (newVal !== oldVal) {
    //     this.$set(this.filter, "keyword", newVal);
    //     await this.getLessonMarkResponseList({
    //       ...this.filter,
    //       page: 1,
    //     });
    //   }
    // },
  },
  computed: {
    ...mapState("teachingCenter", ["seriesList"]),    
    ...mapState("courseCenter", [
      "lessonResponseNameList",
      "lessonResponseNameListLoading",
    ]),
    filter: {
      get() {
        return this.$store.state.courseCenter.markResponseListFilter;
      },
      set(value) {
        this.$store.commit("courseCenter/setData", {
          key: "markResponseListFilter",
          value,
        });
      },
    },
  },
  async mounted() {
    const name = this.$route.params.lessonName;
    this.$set(this.filter, "keyword", name);
    await this.getSeriesList({});
    this.classNameList = this.classNameList.concat(this.seriesList.data);
    console.log(this.filter.classSubjectId);
    if(this.filter.classSubjectId!=undefined) {
       await this.getLessonResponseNameList({classSubjectId: this.filter.classSubjectId, page:1, size: 500});
      this.lessonList = [{
          id: null,
          name: "全部",
        }].concat(this.lessonResponseNameList.data);
    }
    this.onSubmit();
  },
  methods: {
    ...mapActions("courseCenter", ["getLessonMarkResponseList", "getLessonResponseNameList"]),
    ...mapActions("teachingCenter", ["getSeriesList"]),
    ...mapMutations("courseCenter", ["clearMarkFilter"]),
    async classNameChanged(){
      await this.getLessonResponseNameList({classSubjectId: this.filter.classSubjectId, page:1, size: 500});
      this.lessonList = [{
          id: null,
          name: "全部",
        }].concat(this.lessonResponseNameList.data);
      console.log("this.lessonList",this.lessonList)
      this.onSubmit();
    },
    async loadMore() {
      const currentPage = this.seriesList.page;
      const currentSize = this.seriesList.size;
      const currentTotal = this.seriesList.total;
      if (currentPage * currentSize < currentTotal) {
        await this.getSeriesList({
          page: this.seriesList.page + 1,
        });
        this.classNameList = this.classNameList.concat(this.seriesList.data);
      }
    },
    async onSubmit() {
      console.log(this.filter)
      await this.$refs.form.validate(async (valid) => {
        if (valid) {
          await this.getLessonMarkResponseList({
            ...this.filter,
            page: 1,
          });
        }
      });
    },
    // 重置
    async onReset() {
      await this.clearMarkFilter();
      // this.$set(this.filter, "departmentId", this.userDepartmentDictionary[0].id)
      await this.getLessonMarkResponseList({
        page: 1,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.MarkManagement {
  .appBox {
    min-height: calc(100vh - 155px);

    .tableFilter {
      padding-bottom: 20px;

      .el-form-item {
        margin-right: 30px;
      }

      ::v-deep .el-range-separator {
        width: 20px !important;
      }
    }
  }
}
</style>
